import { HOME_ROUTES } from "@constants"
import { dsColorNew } from "@palette"

export const appConfig = {
	// the side menu's brand tile (white car on the app blue)
	favicon: "/assets/favicon.png",
	logo: "/resource/logo192.png",
	emptyImage: '/resource/empty_content.svg',
	appName: "DS Rentacar",
	logoutURL: '/logout',
	header: {
		height: 72,
		showCircle: false,
		showNotifications: false,
		showLang: false,
		showChat: false,
	},
	menu: {
		size: 'extended',
		miniOnLoad: ['/', HOME_ROUTES.HOME_PATH],
		showAppIcon: true,
		spacing: 0,
		nav: {
			width: {
				mini: 100
			}
		}
	}
}

export const styles = {
	main: {
		pl: 5,
		pr: 5,
		// The header is fixed at 72px; the extra 16px keeps floating field labels clear of it
		pt: '88px',
		pb: '32px',
		backgroundColor: dsColorNew.contentBg,
	},
	header: {
		backgroundColor: dsColorNew.white,
		color: dsColorNew.textTitle,
		borderBottom: `1px solid ${dsColorNew.grayBorder}`,
		boxShadow: 'none',
	}
}
